import { createAction } from 'redux-actions'
import Api from '../Api'

import { setAlert } from './alerts'

export const CREATE_EVENT_USER = createAction('CREATE_EVENT_USER')
export const DELETE_EVENT_USER = createAction('DELETE_EVENT_USER')

export const createEventUser = (eventId, user) => {
  return (dispatch) => {
    return Api.createEventUser(eventId, user)
      .then(response => {
        dispatch(CREATE_EVENT_USER({data: response.data}))
        dispatch(setAlert('We have successfully shared this event', undefined, 'success'))
      })
      .catch(error => dispatch(setAlert(error.response.data.message, undefined, 'error')))
  }
}

export const deleteEventUser = (eventId, userId) => {
  return (dispatch) => {
    return dispatch(DELETE_EVENT_USER(Api.deleteEventUser(eventId, userId)))
  }
}



// WEBPACK FOOTER //
// ./src/actions/event-user.js